module.exports = __webpack_public_path__ + "media/motiontech.48a08e6c.mp4";